import { render, staticRenderFns } from "./SugerenciaCurso.vue?vue&type=template&id=ebc88f74&scoped=true"
import script from "./SugerenciaCurso.vue?vue&type=script&lang=js"
export * from "./SugerenciaCurso.vue?vue&type=script&lang=js"
import style0 from "./SugerenciaCurso.vue?vue&type=style&index=0&id=ebc88f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc88f74",
  null
  
)

export default component.exports